// Generates a PrimeVue locale object (datepicker month/day names + first
// day of week) from an i18n locale code, using the platform Intl API so we
// don't hardcode 5 sets of strings.

const MONTHS = Array.from({ length: 12 }, (_, i) => new Date(2024, i, 15));
// 2024-01-07 = Sun, ..., 2024-01-13 = Sat
const DAYS = Array.from({ length: 7 }, (_, i) => new Date(2024, 0, 7 + i));

function fmt(date: Date, locale: string, opts: Intl.DateTimeFormatOptions): string {
  return new Intl.DateTimeFormat(locale, opts).format(date);
}

const FIRST_DOW: Record<string, number> = {
  en: 0, fr: 1, it: 1, de: 1, es: 1,
};

export function primevueLocaleFor(loc: string): Record<string, unknown> {
  const intl = loc === 'en' ? 'en-US' : loc;
  return {
    monthNames:      MONTHS.map((d) => fmt(d, intl, { month: 'long' })),
    monthNamesShort: MONTHS.map((d) => fmt(d, intl, { month: 'short' })),
    dayNames:        DAYS.map((d) => fmt(d, intl, { weekday: 'long' })),
    dayNamesShort:   DAYS.map((d) => fmt(d, intl, { weekday: 'short' })),
    dayNamesMin:     DAYS.map((d) => fmt(d, intl, { weekday: 'narrow' })),
    firstDayOfWeek:  FIRST_DOW[loc] ?? 1,
  };
}
